/**
 * This adds support for necessary stuff to IE11. Our own code has this handled automatically (by babel)
 * so this is mainly for external libraries (esp. dynamically loaded: plyr, dynamic checkout)
 */
import 'core-js/features/array/from';
import 'core-js/features/array/includes';
import 'core-js/features/number/is-nan';
import 'core-js/features/string/includes';
import 'core-js/features/string/starts-with';
import 'core-js/features/object/assign';
import 'core-js/features/object/entries';
import 'core-js/features/object/values';
import 'core-js/features/url';
import 'core-js/features/math/trunc';
import 'custom-event-polyfill';

// Element.closes support
import elementClosest from 'element-closest';

elementClosest(window);
